// State detection service for converting coordinates to states/regions
import { detectStateFromCoordinates, censusBoundingBoxes } from '../utils/censusStateDetection';

const stateDetectionService = {
  // US State boundaries from Census Bureau data
  usStateBounds: censusBoundingBoxes,

  // Detect state from coordinates using accurate Census Bureau polygons
  detectState: (lat: number, lng: number): string | null => {
    console.log(`Detecting state for coordinates: ${lat}, ${lng}`);
    
    // Use the accurate polygon-based detection
    const detectedState = detectStateFromCoordinates(lat, lng);
    
    if (detectedState) {
      console.log(`Matched state using Census polygons: ${detectedState}`);
      return detectedState;
    }
    
    console.log('No state matched');
    return null;
  },

  // Get visited states from memories
  getVisitedStates: (memories: any[]): string[] => {
    const visitedStates = new Set<string>();
    
    console.log('Processing memories for state detection:', memories.length);
    
    memories.forEach((memory, index) => {
      if (memory.latitude && memory.longitude) {
        console.log(`Memory ${index + 1}: lat=${memory.latitude}, lng=${memory.longitude}`);
        const state = stateDetectionService.detectState(memory.latitude, memory.longitude);
        console.log(`  -> Detected state: ${state || 'None'}`);
        if (state) {
          visitedStates.add(state);
        }
      } else {
        console.log(`Memory ${index + 1}: Missing coordinates`);
      }
    });
    
    console.log('Final visited states:', Array.from(visitedStates));
    return Array.from(visitedStates).sort();
  },

  // Generate state visit statistics
  getStateStatistics: (memories: any[]) => {
    const stateStats: { [state: string]: number } = {};
    
    memories.forEach(memory => {
      if (memory.latitude && memory.longitude) {
        const state = stateDetectionService.detectState(memory.latitude, memory.longitude);
        if (state) {
          stateStats[state] = (stateStats[state] || 0) + 1;
        }
      }
    });
    
    return stateStats;
  }
};

export { stateDetectionService };